export default "__VITE_ASSET__BUDk$AmB__"